@if (loading) {
  <div class="loader-overlay">
    <div class="backdrop"></div>
    <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
  </div>
}
<dst-create-disclosure-actions [isView]="false" [disabled]="false" (onSaveClick)="save($event);"
  (onCancelClick)="cancel()">
</dst-create-disclosure-actions>

<div class="form-template-wrapper">
  <div [id]="'form235'">
    <dst-template-header (consolGroupChanged)="onConsolGroupChanged($event)">
    </dst-template-header>

    <!-- Section 0 -->
    <div id="part0" style="margin-top: 15px;">
      <dst-template-leid-selector class="required-field" [label]="'Please specify the LEID of the reporting entity '"
        [labelId]="'1'" (onSelectedLEChanged)="onReportingEntityChanged($event)">
      </dst-template-leid-selector>

      <div class="entity-details">
        <span class="ent-label">Entity Name:</span>
        <span class="template-color-blue">{{!transferor ? '' : transferor.ENTITY}}</span>
      </div>
      <div class="entity-details">
        <span class="ent-label">Federal ID:</span>
        <span class="template-color-blue">{{!transferor ? '' : (transferor.EIN ? transferor.EIN : 'N/A')}}</span>
      </div>
    </div>

    <br />
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
        <tr></tr>
      </tbody>
    </table>

    <!-- Section 1 -->
    <div class="section-content ap-form-field-my-wrapper" id="part1">

      <table>
        <tbody>

          <tr>
            <td class="statement-number-tbl-td">A</td>
            <td colspan="2">
              If you are filing more than one Form
              8886 with your tax return, sequentially number each Form 8886 and
              enter the statement number for this Form 8886.
              <span>
                (Sequential numbering for each Form 8886 and total number of forms filed will be completed
                by Corporate Tax).
              </span>
            </td>
          </tr>

          <tr>
            <td> </td>
            <td style="width: 75%;"> <div class="col-md-12 label-align"> Statement Number </div> </td>
            <ap-field [title]="''" [fieldId]="'statementNumber'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field label-none'" [hideTitleOnInput]="true">
              <input appkit-field aria-label="Statement Number" [(ngModel)]="formModel.statementNumber" />
            </ap-field>
          </tr>

          <tr>
            <td></td>
            <td> <div class="col-md-12 label-align"> of </div> </td>
            <td class="pt-2">
              <ap-field [title]="''" [fieldId]="'totalStatementNumber'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field label-none'" [hideTitleOnInput]="true">
                <input appkit-field aria-label="Total statement number" [(ngModel)]="formModel.totalStatementNumber" />
              </ap-field>
            </td>
          </tr>

          <tr>
            <td class="statement-number-tbl-td">B</td>
            <td>
              <div class="col-md-12 pl-0">
                Enter the form number of the tax return to which this form is attached or related.
              </div>
            </td>
            <td class="pt-2">
              <ap-field [title]="''" [fieldId]="'formNumberOfTaxReturn'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field label-none'" [hideTitleOnInput]="true">
                <input appkit-field aria-label="Form number of tax return" [(ngModel)]="formModel.formNumberOfTaxReturn" />
              </ap-field>
            </td>
          </tr>

          <tr>
            <td>&nbsp;</td>
            <td>Enter the year of the tax return
            identified above.</td>
            <td class="pt-2">
              <ap-dropdown class="field-full-width" [list]="taxReturnYears" [selectType]="'single'"
                [showSearchbox]="true" [title]="'Tax Year'" [inputAriaLabel]="'Tax Year'" [hideTitleOnInput]="true" [(ngModel)]="selectedTaxReturnYearItem"
                (onSelect)="onForTaxYearChanged($event)">
                @for (item of taxReturnYears; track item) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setAriaLabel(item, 'Tax Year')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>
              <div class="col-md-12 pl-0">
                Is this Form 8886 being filed with an amended tax return?
              </div>
            </td>
            <td class="pt-2">
              <ap-radio-group [ariaLabel]="'Is this Form 8886 being filed with an amended tax return?'">
                <ap-radio [styleClass]="'a-mx-10'" name="radio-group-4" [value]="$any(true)"
                  [(ngModel)]="AttachedToAmendedReturn" (onChange)="check2(true)">
                  <span>Yes</span>
                </ap-radio>
                <ap-radio [styleClass]="'a-mx-10'" name="radio-group-4" [value]="$any(false)"
                  [(ngModel)]="AttachedToAmendedReturn" (onChange)="check2(false)">
                  <span>No</span>
                </ap-radio>
              </ap-radio-group>
            </td>
          </tr>

          <tr>
            <td class="statement-number-tbl-td">C</td>
            <td class="pt-2">
              Check the box(es) that apply:
            </td>
            <td>
              <div class="entity-type-options">
                <ap-checkbox [inputId]="'initialYearFiler'"
                  [(ngModel)]="formModel.initialYearFiler"><span>Initial Year Filer</span>
                </ap-checkbox>
                <ap-checkbox [inputId]="'protectiveDisclosure'"
                  [(ngModel)]="formModel.protectiveDisclosure"><span>Protective Disclosure</span>
                </ap-checkbox>
              </div>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
        <tr></tr>
      </tbody>
    </table>

    <!-- Section 2 -->
    <div class="section-content ap-form-field-my-wrapper" id="part2">
      <table>
        <tbody>
          <tr>
            <td class="statement-number-tbl-td">1a</td>
            <td>Name of reportable transaction</td>
          </tr>

          <tr>
            <td></td>
            <td colspan="2">
              <div class="a-textarea-box a-field-length-validation form-inlines">
                <ap-field [title]="''" [fieldId]="'reportableTransactionInfoNameOfReportableTransaction'" [hideTitleOnInput]="true">
                    <textarea appkit-field maxlength="100" [(ngModel)]="formModel.reportableTransactionInfoNameOfReportableTransaction" aria-label="Reportable transaction info name of reportable transaction"></textarea>
                  <ap-field-counter [max]="100" [value]="formModel.reportableTransactionInfoNameOfReportableTransaction"></ap-field-counter>
                </ap-field>
              </div>
            </td>
          </tr>

          <tr>
            <td class="statement-number-tbl-td">1b</td>
            <td style="width: 75%;">Initial year participated in transaction</td>
            <td class="pt-2">
              <ap-dropdown class="field-full-width" [list]="taxYearsPT"
                [hideTitleOnInput]="true" [(ngModel)]="selectedInitialYearItem"
                (onSelect)="onInitialYearParticipatedInTrChanged($event)" [selectType]="'single'" [showSearchbox]="true" [title]="'Tax Year'" [inputAriaLabel]="'Tax Year'">
                @for (item of taxYearsPT; track item) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setAriaLabel(item, 'Tax Year')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </td>
          </tr>

          <tr>
            <td class="statement-number-tbl-td" style="vertical-align: middle;">1c</td>
            <td style="vertical-align: middle;">Reportable transaction or tax shelter
            registration number {{taxYear >= 2023 ? '(1 to 22 digits)' : '(9 digits or 11 digits)'}}</td>
            <td>
              <dst-custom-input class="pl-0 pt-2" [type]="'input'" [value]="formModel.reportableTransactionInfoTransactionOrTaxShelterNumber"
                [id]="'reportableTransactionInfoTransactionOrTaxShelterNumber'" [maxLength]="taxYear >= 2023 ? 22 : 11"
                (valChange)="formModel.reportableTransactionInfoTransactionOrTaxShelterNumber = $event;">
              </dst-custom-input>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
        <tr></tr>
      </tbody>
    </table>

    <!-- Section 3 -->
    <div class="section-content ap-form-field-my-wrapper" id="part3">
      <table>
        <tbody>
          <tr>
            <td class="statement-number-tbl-td">2</td>
            <td class="pb-2">Identify the type of reportable transaction
            below. Check all boxes that apply.</td>
          </tr>

          <tr>
            <td class="statement-number-tbl-td"></td>
            <td colspan="2">
              <div class="reportable-type-grid">
                <div class="reportable-option">
                  <span class="reportable-letter">a</span>
                  <ap-checkbox [inputId]="'reportableListed'" [(ngModel)]="formModel.listed"><span>Listed</span>
                  </ap-checkbox>
                </div>
                <div class="reportable-option">
                  <span class="reportable-letter">c</span>
                  <ap-checkbox [inputId]="'reportableContractualProtection'"
                    [(ngModel)]="formModel.contractualProtection"><span>Contractual Protection</span>
                  </ap-checkbox>
                </div>
                <div class="reportable-option">
                  <span class="reportable-letter">e</span>
                  <ap-checkbox [inputId]="'reportableTransactionOfInterest'"
                    [(ngModel)]="formModel.transactionOfInterest"><span>Transaction of interest</span>
                  </ap-checkbox>
                </div>
                <div class="reportable-option">
                  <span class="reportable-letter">b</span>
                  <ap-checkbox [inputId]="'reportableConfidential'"
                    [(ngModel)]="formModel.confidential"><span>Confidential</span>
                  </ap-checkbox>
                </div>
                <div class="reportable-option">
                  <span class="reportable-letter">d</span>
                  <ap-checkbox [inputId]="'reportableLoss'" [(ngModel)]="formModel.loss"><span>Loss</span>
                  </ap-checkbox>
                </div>
              </div>
            </td>
          </tr>

        <tr>
          <td class="statement-number-tbl-td">3</td>
          <td style="width: 75%">
            If you checked box 2a or 2e, enter the published guidance number for the listed transaction or transaction of interest
          </td>
          <td>
            <ap-field [title]="''" [fieldId]="'publishedGuidanceNumber'" [styleClass]="'form-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="formModel.publishedGuidanceNumber"
                [disabled]="formModel.listed !== true && formModel.transactionOfInterest !== true"  aria-label="Published guidance number" />
              </ap-field>
            </td>
          </tr>

          <tr>
            <td class="statement-number-tbl-td">4</td>
            <td>Enter the number of "same as or
              substantially
            similar" transactions reported on this form</td>
            <td class="pt-2">
              <ap-field [title]="''" [fieldId]="'numberOfSameOrSimilarTr'" [type]="'appkit-number'" [format]="''"
                [styleClass]="'number-field label-none'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="formModel.numberOfSameOrSimilarTr"  aria-label="Number of same or similar tr" />
              </ap-field>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
        <tr></tr>
      </tbody>
    </table>

    <!-- Section 4 -->
    <div class="section-content ap-form-field-my-wrapper" id="part4">

      <table>
        <tbody>
          <tr>
            <td class="statement-number-tbl-td">5</td>
            <td>
              If you participated in the transaction through another entity, check all applicable boxes and provide the information below for the entity
            </td>
          </tr>
        </tbody>
      </table>

      <div class="tab-section section-content">
        <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'" [compact]="true"
          (onClick)="addTab('partFour')">
          <span class="Appkit4-icon icon-plus-outline"></span> Add
        </ap-button>

        <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'"
          [compact]="true"
          [disabled]="partFourTabs.length > 1 && (partFourSelected.value === 0)" (onClick)="removeTab(partFourSelected.value, 'partFour')">
          <span class="Appkit4-icon icon-minus-outline"></span> Remove
        </ap-button>

        <mat-tab-group [selectedIndex]="partFourSelected.value" (selectedIndexChange)="selectTab($event, 'partFour', false)" animationDuration="0ms">
          @for (tab of partFourTabs; track $index; let index = $index) {
            <mat-tab [label]="tab.tab">

              <div class="tab-section-content">

                <table class="entity-type-table">
                  <tbody>
                    <tr>
                      <td class="statement-number-tbl-td">a</td>
                      <td colspan="2">Type of entity</td>
                    </tr>

                    <tr>
                      <td class="statement-number-tbl-td"></td>
                      <td colspan="2">
                        <div class="entity-type-options">
                          <ap-checkbox [inputId]="'typeOfEntityInformationPartnership_' + index"
                            [(ngModel)]="tab.typeOfEntityInformationPartnership"><span>Partnership</span>
                          </ap-checkbox>
                          <ap-checkbox [inputId]="'typeOfEntityInformationSCorporation_' + index"
                            [(ngModel)]="tab.typeOfEntityInformationSCorporation"><span>S corporation</span>
                          </ap-checkbox>
                          <ap-checkbox [inputId]="'typeOfEntityInformationTrust_' + index"
                            [(ngModel)]="tab.typeOfEntityInformationTrust"><span>Trust</span>
                          </ap-checkbox>
                          <ap-checkbox [inputId]="'typeOfEntityInformationForeign_' + index"
                            [(ngModel)]="tab.typeOfEntityInformationForeign"><span>Foreign</span>
                          </ap-checkbox>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="statement-number-tbl-td"></td>
                      <td>Please specify the LEID of the Entity that Participated in the Transaction</td>
                      <td>
                        <dst-template-leid-selector [labelId]="'participatingEntity_'+index" [id]="'participatingEntity'"
                          [label]="''" (onSelectedLEChanged)="onParticipatingLEIDChanged($event, index)" required
                        [ngClass]="{ 'required-field': tab.typeOfEntityInformationPartnership || tab.typeOfEntityInformationSCorporation
                          || tab.typeOfEntityInformationTrust || tab.typeOfEntityInformationForeign }">
                        </dst-template-leid-selector>
                      </td>
                    </tr>

                    <tr>
                      <td class="statement-number-tbl-td">b</td>
                      <td>Entity Name:</td>
                      <td>
                        <span class="template-color-blue"> {{!tab.participatingEntity ? '' : tab.participatingEntity.ENTITY}} </span>
                      </td>
                    </tr>

                    <tr>
                      <td class="statement-number-tbl-td">c</td>
                      <td>Employer identification number (EIN):</td>
                      <td>
                        <span class="template-color-blue"> {{!tab.participatingEntity ? '' : (tab.participatingEntity.EIN ? tab.participatingEntity.EIN : 'N/A')}} </span>
                      </td>
                    </tr>

                    @if (tab.participatingEntity && tab.participatingEntity.EIN === undefined) {
                      <tr>
                        <td class="statement-number-tbl-td">&nbsp;</td>
                        <td>EIN Missing Reason:</td>
                        <td>
                          <ap-dropdown class="required-field ap-form-field-my-wrapper" [id]="'typeOfEntityInformationMissingEINReason'" [showSearchbox]="true"
                            [list]="reasonsEIN" [selectType]="'single'" [title]="'EIN Missing Reason'" [inputAriaLabel]="'EIN Missing Reason'" [hideTitleOnInput]="true" [(ngModel)]="tab.selectedEINReasonItem"
                            (onSelect)="onInvInTrMissingEINChange($event, index)">
                            @for (item of reasonsEIN; track item) {
                              <ap-dropdown-list-item #dropdownListItem [item]="item"
                                [ariaLabel]="setAriaLabel(item, 'EIN Missing Reason')"
                              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                            }
                          </ap-dropdown>
                        </td>
                      </tr>
                    }

                    <tr>
                      <td class="statement-number-tbl-td">d</td>
                      <td>
                        On the next two rows, enter either the Date Schedule K-1 received from entity or "none" if Schedule K-1 not received
                      </td>
                    </tr>

                    <tr>
                      <td class="statement-number-tbl-td">&nbsp;</td>
                      <td>Date Schedule K-1 received from entity</td>
                      <td class="d-flex">
                        @if (showDate) {
                          <app-date-picker-with-clear

                            [minDate]="beginDate"
                            [maxDate]="endDate"
                            [datePickerClass]="''"
                            [required]="false"
                            (dateChange)="dateChange($event, index)"
                            (datePickerClick)="onDPOpen()"
                            (clearClick)="clearDate(index)"
                            [(ngModel)]="tab.typeOfEntityInformationScheduleK1ReceivedDate">
                          </app-date-picker-with-clear>
                        }
                      </td>
                    </tr>

                    <tr>
                      <td class="statement-number-tbl-td">&nbsp;</td>
                      <td> If no Schedule K-1 was received from the entity enter "NONE" </td>
                      <td>
                        <ap-field [title]="''" [fieldId]="'noneEntity'" [styleClass]="'disabled-input'" [hideTitleOnInput]="true">
                    <input appkit-field [disabled]="true"
                            [(ngModel)]="tab.typeOfEntityInformationNoScheduleK1Received"  aria-label="None entity" />
                          </ap-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <ap-button class="ap-mr-spacing-3" [btnType]="'secondary'"
                    [compact]="true" (onClick)="clearEntity('partFour', index)">
                    <span class="Appkit4-icon a-btn-icon icon-refresh-fill"></span>Clear this Entry
                  </ap-button>

                </div>

              </mat-tab>
            }
          </mat-tab-group>

        </div>

      </div>

      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
          <tr></tr>
        </tbody>
      </table>

      <!-- Section 5 -->
      <div class="section-content ap-form-field-my-wrapper" id="part5">

        <table>
          <tbody>
            <tr>
              <td class="statement-number-tbl-td">6</td>
              <td>
                Enter below the name and address of each
                individual or entity to whom you paid a fee with regard to the
                transaction if that individual or entity promoted, solicited, or
                recommended your participation in the transaction, or provided tax
                advice related to the transaction.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="tab-section section-content">
          <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'" [compact]="true"
            (onClick)="addTab('partFive')">
            <span class="Appkit4-icon icon-plus-outline"></span> Add
          </ap-button>

          <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'"
            [compact]="true"
            [disabled]="partFiveTabs.length > 1 && partFiveSelected.value === 0" (onClick)="removeTab(partFiveSelected.value, 'partFive')">
            <span class="Appkit4-icon icon-minus-outline"></span> Remove
          </ap-button>

          <mat-tab-group [selectedIndex]="partFiveSelected.value" (selectedIndexChange)="selectTab($event, 'partFive', false)"
            animationDuration="0ms">
            @for (tab of partFiveTabs; track $index; let index = $index) {
              <mat-tab [label]="tab.tab">
                <div class="tab-section-content">

                  <div class="row mt-2 w-100">
                    <div class="col-md-4">
                      <span>Name</span>
                    </div>
                    <div class="col-md-8 pl-2">
                      <ap-field [title]="''" [fieldId]="'personNameYouPaid'" [styleClass]="'label-none'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoNameOfPersonYouPaidFee"  aria-label="Person name you paid" />
                      </ap-field>
                    </div>
                  </div>

                  <div class="row mt-2 w-100">
                    <div class="col-md-4">
                      <span>Identifying Number: SSN (If Known)</span>
                    </div>
                    <div class="col-md-8 pl-2">
                      <ap-field [title]="''" [fieldId]="'personSSNYouPaid'" [type]="'appkit-number'" [format]="''" [styleClass]="'label-none'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoSSNNumberPersonPaidFee"
                          (ngModelChange)="personsYouPaidAFeeInfoEINChange({value: $event}, index)"  aria-label="Person ssnyou paid" />
                        </ap-field>
                      </div>
                    </div>

                    <div class="row mt-2 w-100">
                      <div class="col-md-4">
                        <span>Identifying Number: EIN (If Known)</span>
                      </div>
                      @if (!USForeignFeesRad) {
                        <div class="col-md-8 pl-2">
                          <ap-field [title]="''" [fieldId]="'personEINYouPaid'" [type]="'appkit-number'" [format]="''" [styleClass]="'label-none'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee"
                              (ngModelChange)="personsYouPaidAFeeInfoEINChange({value: $event}, index)"  aria-label="Person einyou paid" />
                            </ap-field>
                            <!-- <dst-custom-input class="dst-field" id="personEINYouPaid" [label]="''" [maxLength]="9" [value]="tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee"
                            (valChange)="tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee = $event;" (onChangeEvent)="personsYouPaidAFeeInfoEINChange($event, index)">
                          </dst-custom-input> -->
                        </div>
                      }
                      @if (USForeignFeesRad) {
                        <div class="col-md-8 pl-0">
                          <!-- <ap-form-field [inlineBlock]="true" [type]="'inputNumber'" class="label-none"
                          [funType]="'typeTwo'" [id]="'personEINYouPaid'" (onChangeEvent)="personsYouPaidAFeeInfoEINChange($event, index)"
                          [(ngModel)]="tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee">
                        </ap-form-field> -->
                        <dst-custom-input class="dst-field" id="personEINYouPaid" [label]="''" [maxLength]="9" [value]="tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee"
                          (valChange)="tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee = $event;" (onChangeEvent)="personsYouPaidAFeeInfoEINChange($event, index)">
                        </dst-custom-input>
                      </div>
                    }
                  </div>

                  @if ((tab.personsYouPaidAFeeInfoSSNNumberPersonPaidFee === '' || tab.personsYouPaidAFeeInfoSSNNumberPersonPaidFee == null) && (tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee === '' || tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee == null) ) {
                    <div class="row mt-2 w-100">
                      <div class="col-md-4 pr-0">
                        <span>If no SSN/EIN, specify reason for missing tax ID Number</span>
                      </div>
                      <div class="col-md-8 pt-1 pl-2">
                        <ap-dropdown class="ap-form-field-my-wrapper" [id]="'personsYouPaidAFeeInfoMissingEINReasonPersonPaidFee'"
                          [list]="partFiveReasonsEIN" [selectType]="'single'" [showSearchbox]="true" [title]="'Select'" [inputAriaLabel]="'Select'"
                          [hideTitleOnInput]="true" [(ngModel)]="tab.selectedPartFiveEINItem"
                          (onSelect)="personsYouPaidAFeeInfoMissingEINReasonChange($event, index)"
                    [ngClass]="{ 'required-field': (tab.personsYouPaidAFeeInfoNameOfPersonYouPaidFee != '') && ((tab.personsYouPaidAFeeInfoSSNNumberPersonPaidFee == '' || tab.personsYouPaidAFeeInfoSSNNumberPersonPaidFee == null)
                      && (tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee == '' || tab.personsYouPaidAFeeInfoEINNumberPersonPaidFee == null)) }">
                          @for (item of partFiveReasonsEIN; track item) {
                            <ap-dropdown-list-item #dropdownListItem [item]="item"
                              [ariaLabel]="setAriaLabel(item, 'Select')"
                            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                          }
                        </ap-dropdown>
                      </div>
                    </div>
                  }

                  <div class="row mt-2 w-100">
                    <div class="col-md-4">
                      <span>Fees Paid (Enter amount in US Dollars)</span>
                    </div>
                    <div class="col-md-8 pl-2">
                      <ap-field [title]="''" [fieldId]="'personFeeYouPaid'" [type]="'appkit-number'" [format]="''" [styleClass]="'label-none'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoFeesPaid"  aria-label="Person fee you paid" />
                      </ap-field>
                    </div>
                  </div>

                  <div class="row mt-2 w-100">
                    <div class="col-md-4">
                      <span>Were Fees paid to a US or Foreign Entity?</span>
                    </div>
                    <div class="col-md-4 pl-0">
                      <ap-radio [styleClass]="'a-mx-10'" name="radio-group-3_{{ tab.tab }}"
                        (onChange)="check3(true, index)" [(ngModel)]="tab.USFeesRad" [value]="$any(true)">
                        <span>US</span>
                      </ap-radio>
                      <ap-radio [styleClass]="'a-mx-10'" name="radio-group-3_{{ tab.tab }}"
                        (onChange)="check3(false, index)" [(ngModel)]="tab.USFeesRad" [value]="$any(false)">
                        <span>Foreign</span>
                      </ap-radio>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="entity-details">
                        <span class="ed-label">Address Line 1:</span>
                        <div class="col-md-8 pr-1">
                          <ap-field [title]="''" [fieldId]="'personsYouPaidAFeeInfoAddressLine1'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoAddressLine1"  aria-label="Persons you paid afee info address line1" />
                          </ap-field>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="entity-details">
                        <span class="ed-label">Address Line 2:</span>
                        <div class="col-md-8 pr-1">
                          <ap-field [title]="''" [fieldId]="'personsYouPaidAFeeInfoAddressLine2'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoAddressLine2"  aria-label="Persons you paid afee info address line2" />
                          </ap-field>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="entity-details">
                        <span class="ed-label">{{ USForeignFeesRad ? 'City:' : 'City / Town:'}}</span>
                        <div class="col-md-8 pr-1">
                          <ap-field [title]="''" [fieldId]="'personsYouPaidAFeeInfoCity'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoCity"  aria-label="Persons you paid afee info city" />
                          </ap-field>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      @if (USForeignFeesRad) {
                        <div class="entity-details">
                          <span class="ed-label">State:</span>
                          <div class="col-md-8  pt-1 pr-1">
                            <ap-dropdown [list]="states" [selectType]="'single'" [showSearchbox]="true" [title]="'State'" [inputAriaLabel]="'State'"
                              [hideTitleOnInput]="true" [(ngModel)]="tab.selectedStateItem"
                              (onSelect)="personsYouPaidAFeeInfoStateChange($event, index)">
                              @for (item of states; track item) {
                                <ap-dropdown-list-item #dropdownListItem [item]="item"
                                  [ariaLabel]="setAriaLabel(item, 'State')"
                                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                              }
                            </ap-dropdown>
                          </div>
                        </div>
                      }
                      @if (!USForeignFeesRad) {
                        <div class="entity-details">
                          <span class="ed-label">Province or State:</span>
                          <div class="col-md-8 pr-1">
                            <ap-field [title]="''" [fieldId]="'personsYouPaidAFeeInfoProvinceOrState'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoProvinceOrState"  aria-label="Persons you paid afee info province or state" />
                            </ap-field>
                          </div>
                        </div>
                      }
                    </div>
                  </div>

                  @if (!USForeignFeesRad) {
                    <div class="row">
                      <div class="col-md-12">
                        <div class="entity-details">
                          <span class="ed-label">Country:</span>
                          <div class="col-md-8 pt-1 pr-1">
                            <ap-dropdown [list]="countries" [selectType]="'single'"
                              [showSearchbox]="true" [title]="'Country'" [inputAriaLabel]="'Country'" [hideTitleOnInput]="true" [(ngModel)]="tab.selectedCountryItem"
                              (onSelect)="personsYouPaidAFeeInfoCountryChange($event, index)">
                              @for (item of countries; track item) {
                                <ap-dropdown-list-item #dropdownListItem [item]="item"
                                  [ariaLabel]="setAriaLabel(item, 'Country')"
                                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                              }
                            </ap-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <div class="row">
                    <div class="col-md-12">
                      <div class="entity-details">
                        <span class="ed-label">{{ USForeignFeesRad ? 'Zip Code:' : 'Postal Code:'}}</span>
                        <div class="col-md-8 pr-1">
                          <ap-field [title]="''" [fieldId]="'zip'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.personsYouPaidAFeeInfoZip"  aria-label="Zip" />
                          </ap-field>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </mat-tab>
            }
          </mat-tab-group>

        </div>
      </div>

      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
          <tr>

          </tr>
        </tbody>
      </table>

      <!-- Section 6 -->
      <div class="section-content ap-form-field-my-wrapper" id="part6">

        <table>
          <tbody>
            <tr>
              <td class="statement-number-tbl-td">7</td>
              <td>Facts</td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>

        <div style="padding-left: 48px;">

          <table>
            <tbody>
              <tr>
                <td class="statement-number-tbl-td">a</td>
                <td>
                  Identify the type of tax benefit generated by the transaction. Check all the boxes that apply.
                </td>
                <td>&nbsp;</td>
              </tr>

              <tr>
                <td class="statement-number-tbl-td"></td>
                <td>
                  <table>
                    <tbody>

                      <tr>
                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'Deductions'"
                            [(ngModel)]="formModel.deductions"><span>Deductions</span>
                          </ap-checkbox>
                        </td>

                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'ExclusionsFromGrossIncome'"
                            [(ngModel)]="formModel.exclusionsFromGrossIncome"><span> Exclusions From Gross Income</span>
                          </ap-checkbox>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'capitalLoss'"
                            [(ngModel)]="formModel.capitalLoss"><span>Capital Loss</span>
                          </ap-checkbox>
                        </td>

                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'nonrecognitionOfGain'"
                            [(ngModel)]="formModel.nonrecognitionOfGain"><span>Nonrecognition of gain</span>
                          </ap-checkbox>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'ordinaryLoss'"
                            [(ngModel)]="formModel.ordinaryLoss"><span>Ordinary Loss</span>
                          </ap-checkbox>
                        </td>

                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'adjustmentsToBasis'"
                            [(ngModel)]="formModel.adjustmentsToBasis"><span>Adjustments to basis</span>
                          </ap-checkbox>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'line7aOther'"
                            [(ngModel)]="formModel.line7aOther"><span>Other</span>
                          </ap-checkbox>
                        </td>

                        <td width="50%">
                          @if (formModel.line7aOther) {
                            <ap-field [title]="''" [fieldId]="'line7aOtherText'"
                              [styleClass]="'ap-form-field-my-wrapper other-text-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="formModel.line7aOtherText"  aria-label="Line7a other text" />
                            </ap-field>
                          }
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td class="statement-number-tbl-td">&nbsp;</td>
                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'taxCredits'"
                            [(ngModel)]="formModel.taxCredits"><span> Tax Credits</span>
                          </ap-checkbox>
                        </td>
                      </tr>

                      <tr>
                        <td class="statement-number-tbl-td">&nbsp;</td>
                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'deferral'"
                            [(ngModel)]="formModel.deferral"><span>Deferral</span>
                          </ap-checkbox>
                        </td>
                      </tr>

                      <tr>
                        <td class="statement-number-tbl-td">&nbsp;</td>
                        <td>
                          <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'absenceOfAdjustmentsToBasis'"
                            [(ngModel)]="formModel.absenceOfAdjustmentsToBasis"><span>Absence of adjustments to basis</span>
                          </ap-checkbox>
                        </td>
                      </tr>

                      <tr>
                        <td class="statement-number-tbl-td">&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>

                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td class="statement-number-tbl-td">b</td>

                <td class="pt-2">
                  Enter the total dollar amount of your tax benefits identified in 7a. See instructions
                </td>

                <td class="col-md-3 pb-2">
                  <div class="d-flex part-two part-two--fixed-number-field">
                    <span class="currency-prefix">$</span>
                    <ap-field [title]="''" [fieldId]="'benefitsAmt'" [type]="'appkit-number'" [format]="''"
                      [styleClass]="'number-field required-field number-field-box'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="formModel.totalTaxBenefitAmt"  aria-label="Benefits amt" />
                    </ap-field>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="statement-number-tbl-td">c</td>

                <td>
                  Enter the anticipated number of years the transaction provides the tax benefits stated in 7b. See instructions
                </td>

                <td class="col-md-3 pb-2">
                  <div class="d-flex part-two part-two--fixed-number-field">
                    <span class="currency-prefix currency-prefix--spacer" aria-hidden="true">$</span>
                    <ap-field [title]="''" [fieldId]="'anticipatedAmt'" [type]="'appkit-number'" [format]="''"
                      [styleClass]="'number-field required-field number-field-box'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="formModel.taxBnftAnticipatedYrCnt"  aria-label="Anticipated amt" />
                    </ap-field>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="statement-number-tbl-td">d</td>

                <td>
                  Enter your total investment or basis in the transaction. See instructions
                </td>

                <td class="col-md-3 pb-2">
                  <div class="d-flex part-two part-two--fixed-number-field">
                    <span class="currency-prefix">$</span>
                    <ap-field [title]="''" [fieldId]="'invOrBasisAmt'" [type]="'appkit-number'" [format]="''"
                      [styleClass]="'number-field required-field number-field-box'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="formModel.totalInvestmentOrBasisAmt"  aria-label="Inv or basis amt" />
                    </ap-field>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="statement-number-tbl-td">e</td>
                <td width="65%">Please specify a Word Document that further
                  describes the amount and nature of the expected tax treatment and
                  expected tax benefits generated by the transaction for all affected
                  years. Include facts of each step of the transaction that relate to
                  the expected tax benefits including the amount and nature of your
                  investment. Include in your description your participation in the
                  transaction and all related transactions regardless of the year in
                  which they were entered into. Also, include a description of any tax
                  result protection with respect to the transaction
                </td>
                <td>&nbsp;</td>
              </tr>

            </tbody>
          </table>

        </div>

        <div class="row mt-2 justify-content-center">
          <button id="uploadPdf" class="file-upload-btn">
            <input type="file" [accept]="fileAcceptStr" (change)="onFileChanged($event)" #fileUpload style="height: 1.7rem !important;">
          </button>
          @if (downloadUrl) {
            <div class="col-md-8 text-align-center">
              <span><a class="attachment" (click)="download()"> {{ attachmentname }} </a></span>
              <span class="Appkit4-icon icon-delete-fill ml-2" (click)="deleteFileUrl()"></span>
            </div>
          }
        </div>

      </div>

      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
          <tr>

          </tr>
        </tbody>
      </table>

      <!-- Section 7 -->
      <div class="section-content ap-form-field-my-wrapper" id="part7">

        <table>
          <tbody>
            <tr>
              <td class="statement-number-tbl-td">8</td>
              <td>
                Identify all tax-exempt, foreign, and related
                entities and individuals involved in the transaction. Check the
                appropriate box(es). Include their name(s), identifying number(s),
                address(es), and a brief description of their involvement. For each
                foreign entity, identify its country of incorporation or existence.
                For each related entity, explain how it is related.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="tab-section section-content">
          <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'" [compact]="true"
            (onClick)="addTab('partSeven')">
            <span class="Appkit4-icon icon-plus-outline"></span> Add
          </ap-button>

          <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'"
            [compact]="true"
            [disabled]="partSevenTabs.length > 1 && partSevenSelected.value === 0" (onClick)="removeTab(partSevenSelected.value, 'partSeven')">
            <span class="Appkit4-icon icon-minus-outline"></span> Remove
          </ap-button>

          <mat-tab-group [selectedIndex]="partSevenSelected.value" (selectedIndexChange)="selectTab($event, 'partSeven', false)"
            animationDuration="0ms">
            @for (tab of partSevenTabs; track $index; let index = $index) {
              <mat-tab [label]="tab.tab">

                <div class="tab-section-content mt-2">

                  <table class="entity-type-table">
                    <tbody>
                      <tr>
                        <td class="statement-number-tbl-td">a</td>
                        <td>Type of Entity:</td>
                        <td>
                          <div class="entity-type-options">
                            <ap-checkbox [inputId]="'identifyAllInvolvedInTrTaxExempt_' + index"
                              [(ngModel)]="tab.identifyAllInvolvedInTrTaxExempt"><span>Tax-exempt</span>
                            </ap-checkbox>
                            <ap-checkbox [inputId]="'identifyAllInvolvedInTrForeign_' + index"
                              [(ngModel)]="tab.identifyAllInvolvedInTrForeign"><span>Foreign</span>
                            </ap-checkbox>
                            <ap-checkbox [inputId]="'identifyAllInvolvedInTrRelated_' + index"
                              [(ngModel)]="tab.identifyAllInvolvedInTrRelated"><span>Related</span>
                            </ap-checkbox>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="statement-number-tbl-td"></td>
                        <td>Is Participating Entity in Legal Entity Database?</td>
                        <td class="pl-2">
                          <ap-radio [styleClass]="'a-mx-10'" name="radio-group-2_{{ tab.tab }}" [inputId]="'inGOLD_Yes'"
                            (onChange)="check4(true, index)" [(ngModel)]="tab.inGOLDYes" [value]="$any(true)">
                            <span>Yes</span>
                          </ap-radio>
                          <ap-radio [styleClass]="'a-mx-10'" name="radio-group-2_{{ tab.tab }}" [inputId]="'inGOLD_No'"
                            (onChange)="check4(false, index)" [(ngModel)]="tab.inGOLDYes" [value]="$any(false)">
                            <span>No</span>
                          </ap-radio>
                        </td>
                      </tr>

                      @if (tab.inGOLDYes) {
                        <tr>
                          <td class="statement-number-tbl-td"></td>
                          <td>Please specify the LEID of the Entity that Participated in the Transaction</td>
                          <td class="pl-3">
                            <dst-template-leid-selector [labelId]="'identifyAllInvolvedInTrLEID_'+index" [id]="'involvedTrEntity'"
                              [label]="''" (onSelectedLEChanged)="onInvolvedTrEntityChanged($event, index)"  required
                        [ngClass]="{ 'required-field': (tab.identifyAllInvolvedInTrTaxExempt || tab.identifyAllInvolvedInTrForeign
                          || tab.identifyAllInvolvedInTrRelated) && tab.inGOLDYes }">
                            </dst-template-leid-selector>
                          </td>
                        </tr>
                      }

                      @if (tab.inGOLDYes) {
                        <tr>
                          <td class="statement-number-tbl-td">b</td>
                          <td>Entity Name:</td>
                          <td>
                            <span class="template-color-blue">{{!tab.involvedTrEntity ? '' : tab.involvedTrEntity.ENTITY}}</span>
                          </td>
                        </tr>
                      }

                      @if (tab.inGOLDYes) {
                        <tr>
                          <td class="statement-number-tbl-td">c</td>
                          <td>Employer identification number (EIN):</td>
                          <td>
                            <span class="template-color-blue">{{!tab.involvedTrEntity ? '' : (tab.involvedTrEntity.EIN ? tab.involvedTrEntity.EIN : 'N/A')}}</span>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDYes) && tab.involvedTrEntity && (tab.involvedTrEntity.EIN === undefined)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>EIN Missing Reason:</td>
                          <td class="pt-2 pl-0 col-md-3">
                            <ap-dropdown class="ap-form-field-my-wrapper required-field" [id]="'identifyAllInvolvedInTrMissingEINReason'"
                              [list]="partSevenReasonsEIN" [selectType]="'single'" [required]="true" [showSearchbox]="true" [title]="'EIN Missing Reason'" [inputAriaLabel]="'EIN Missing Reason'"
                              [hideTitleOnInput]="true" [(ngModel)]="tab.selectedPart7EINItem"
                              (onSelect)="missingEINReasonInGoldInvolvedInTrChange($event, index)">
                              @for (item of partSevenReasonsEIN; track item) {
                                <ap-dropdown-list-item #dropdownListItem [item]="item"
                                  [ariaLabel]="setAriaLabel(item, 'EIN Missing Reason')"
                                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                              }
                            </ap-dropdown>
                          </td>
                        </tr>
                      }

                      @if (tab.inGOLDNo) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>Name of Entity</td>
                          <td class="col-md-3 pt-2">
                            <ap-field [title]="''" [fieldId]="'nameInvolvedInTransactionBusinessNameLine1'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.nameInvolvedInTransactionBusinessNameLine1"
                          [ngClass]="{ 'required-field': (tab.identifyAllInvolvedInTrTaxExempt || tab.identifyAllInvolvedInTrForeign
                            || tab.identifyAllInvolvedInTrRelated) && (tab.nameInvolvedInTransactionBusinessNameLine1 == '') }"  aria-label="Name involved in transaction business name line1" />
                              </ap-field>
                            </td>
                          </tr>
                        }

                        @if (tab.inGOLDNo) {
                          <tr>
                            <td class="statement-number-tbl-td">&nbsp;</td>
                            <td>Name Entity Line 2</td>
                            <td class="col-md-3 pt-2">
                              <ap-field [title]="''" [fieldId]="'identifyAllInvolvedInTrNameInvolvedInTransactionBusinessNameLine2'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrNameInvolvedInTransactionBusinessNameLine2"  aria-label="Identify all involved in tr name involved in transaction business name line2" />
                              </ap-field>
                            </td>
                          </tr>
                        }

                        @if (tab.inGOLDNo) {
                          <tr>
                            <td class="statement-number-tbl-td">&nbsp;</td>
                            <td>Identifying Number SSN</td>
                            <td class="col-md-3 pt-2">
                              <ap-field [title]="''" [fieldId]="'ssnNumberInvolvedInTransaction'" [type]="'appkit-number'" [format]="''" [styleClass]="'label-none'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrSSNNumberInvolvedInTransaction"  aria-label="Ssn number involved in transaction" />
                              </ap-field>
                            </td>
                          </tr>
                        }

                        @if (tab.inGOLDNo && InvolvedUSForeignEntity) {
                          <tr>
                            <td class="statement-number-tbl-td">&nbsp;</td>
                            <td>Identifying Number EIN</td>
                            <td class="col-md-3 pt-2" style="padding-left: 7px;">
                              <dst-custom-input class="dst-field" id="einNumberInvolvedInTransaction" [label]="''" [maxLength]="9" [value]="tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction"
                                (valChange)="tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction = $event;" >
                              </dst-custom-input>
                              <!-- <ap-form-field [inlineBlock]="true" [type]="'inputNumber'" class="label-none"
                              [funType]="'typeTwo'" [id]="'einNumberInvolvedInTransaction'"
                              [(ngModel)]="tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction">
                            </ap-form-field> -->
                          </td>
                        </tr>
                      }
                      @if (tab.inGOLDNo && !InvolvedUSForeignEntity) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>Identifying Number EIN</td>
                          <td class="col-md-3 pt-2">
                            <ap-field [title]="''" [fieldId]="'einNumberInvolvedInTransaction'" [type]="'appkit-number'" [format]="''" [styleClass]="'label-none'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction"  aria-label="Ein number involved in transaction" />
                            </ap-field>
                          </td>
                        </tr>
                      }

                      @if (tab.inGOLDNo && ((tab.identifyAllInvolvedInTrSSNNumberInvolvedInTransaction == '' || tab.identifyAllInvolvedInTrSSNNumberInvolvedInTransaction == null) && (tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction == '' || tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction == null))) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>If no Identifying Number, specify reason</td>
                          <td class="col-md-3 pt-2">
                            <ap-dropdown class="ap-form-field-my-wrapper" [id]="'missingEINReasonInvolvedInTr'" [required]="true" [showSearchbox]="true" [title]="'Select'" [inputAriaLabel]="'Select'"
                              [list]="partSevenInvolvedReasonsEIN" [selectType]="'single'" [hideTitleOnInput]="true" [(ngModel)]="tab.selectedPart7InvolvedEINItem"
                              (onSelect)="missingEINReasonInvolvedInTrChange($event, index)"
                        [ngClass]="{ 'required-field': (tab.identifyAllInvolvedInTrTaxExempt || tab.identifyAllInvolvedInTrForeign || tab.identifyAllInvolvedInTrRelated)
                          && (tab.nameInvolvedInTransactionBusinessNameLine1 != '') && ((tab.identifyAllInvolvedInTrSSNNumberInvolvedInTransaction == '' || tab.identifyAllInvolvedInTrSSNNumberInvolvedInTransaction == null)
                          && (tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction == '' || tab.identifyAllInvolvedInTrEINNumberInvolvedInTransaction == null)) }">
                              @for (item of partSevenInvolvedReasonsEIN; track item) {
                                <ap-dropdown-list-item #dropdownListItem [item]="item"
                                  [ariaLabel]="setAriaLabel(item, 'Select')"
                                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                              }
                            </ap-dropdown>
                          </td>
                        </tr>
                      }

                      @if (tab.inGOLDNo) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>Is this a US or Foreign Entity?</td>
                          <td class="pt-2 pl-2">
                            <ap-radio [styleClass]="'a-mx-10'" name="radio-group-1_{{ tab.tab }}" [inputId]="'usForPart8Rad'"
                              (onChange)="check5(true, index)" [(ngModel)]="tab.USForPart8Rad" [value]="$any(true)">
                              <span>US</span>
                            </ap-radio>
                            <ap-radio [styleClass]="'a-mx-10'" name="radio-group-1_{{ tab.tab }}" [inputId]="'foreignForPart8Rad'"
                              (onChange)="check5(false, index)" [(ngModel)]="tab.USForPart8Rad" [value]="$any(false)">
                              <span>Foreign</span>
                            </ap-radio>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDNo) && (InvolvedUSForeignEntity !== undefined)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>Address Line 1:</td>
                          <td class="col-md-3 pt-2">
                            <ap-field [styleClass]="'required-field ap-form-field-my-wrapper'" [title]="''"
                              [fieldId]="'identifyAllInvolvedInTrAddressLine1'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrAddressLine1"  aria-label="Identify all involved in tr address line1" />
                            </ap-field>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDNo) && (InvolvedUSForeignEntity !== undefined)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>Address Line 2:</td>
                          <td class="col-md-3 pt-2">
                            <ap-field [styleClass]="'ap-form-field-my-wrapper'" [title]="''"
                              [fieldId]="'identifyAllInvolvedInTrAddressLine2'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrAddressLine2"  aria-label="Identify all involved in tr address line2" />
                            </ap-field>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDNo) && (InvolvedUSForeignEntity !== undefined)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>{{ InvolvedUSForeignEntity ? 'City:' : 'City / Town:'}}</td>
                          <td class="col-md-3 pt-2">
                            <ap-field [styleClass]="'required-field ap-form-field-my-wrapper'" [title]="''"
                              [fieldId]="'identifyAllInvolvedInTrCity'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrCity"  aria-label="Identify all involved in tr city" />
                            </ap-field>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDNo) && (InvolvedUSForeignEntity === true)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>State:</td>
                          <td class="col-md-3 pt-2">
                            <ap-dropdown class="" [list]="involvedTrStates"
                              [showSearchbox]="true" [id]="'identifyAllInvolvedInTrState'" [selectType]="'single'" [title]="'State'" [inputAriaLabel]="'State'"
                              [hideTitleOnInput]="true" [(ngModel)]="tab.selectedInvolvedStateItem"
                              (onSelect)="identifyAllInvolvedInTrStateChange($event, index)"> <!--, 'required-field-dropdown': USForPart8Rad.value -->
                              @for (item of involvedTrStates; track item) {
                                <ap-dropdown-list-item #dropdownListItem [item]="item"
                                  [ariaLabel]="setAriaLabel(item, 'State')"
                                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                              }
                            </ap-dropdown>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDNo) && (InvolvedUSForeignEntity === false)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>Province or State:</td>
                          <td class="col-md-3 pt-2">
                            <ap-field [styleClass]="'required-field ap-form-field-my-wrapper'" [title]="''"
                              [fieldId]="'identifyAllInvolvedInTrProvinceOrState'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrProvinceOrState"  aria-label="Identify all involved in tr province or state" />
                            </ap-field>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDNo) && (InvolvedUSForeignEntity === false)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>Country:</td>
                          <td class="col-md-3 pt-2">
                            <ap-dropdown class="" [list]="involvedTrCountries"
                              [showSearchbox]="true" [id]="'identifyAllInvolvedInTrCountry'" [selectType]="'single'" [title]="'Country'" [inputAriaLabel]="'Country'"
                              [hideTitleOnInput]="true" [(ngModel)]="tab.selectedInvolvedCountryItem"
                              (onSelect)="identifyAllInvolvedInTrCountryChange($event, index)"> <!--, 'required-field-dropdown': USForPart8Rad.value -->
                              @for (item of involvedTrCountries; track item) {
                                <ap-dropdown-list-item #dropdownListItem [item]="item"
                                  [ariaLabel]="setAriaLabel(item, 'Country')"
                                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                              }
                            </ap-dropdown>
                          </td>
                        </tr>
                      }

                      @if ((tab.inGOLDNo) && (InvolvedUSForeignEntity !== undefined)) {
                        <tr>
                          <td class="statement-number-tbl-td">&nbsp;</td>
                          <td>{{ InvolvedUSForeignEntity ? 'Zip Code:' : 'Postal Code:'}}</td>
                          <td class="col-md-3 pt-2">
                            <ap-field [styleClass]="'required-field ap-form-field-my-wrapper'" [title]="''"
                              [fieldId]="'identifyAllInvolvedInTrPostalCode'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="tab.identifyAllInvolvedInTrPostalCode"  aria-label="Identify all involved in tr postal code" />
                            </ap-field>
                          </td>
                        </tr>
                      }

                      <br />
                      <tr>
                        <td class="statement-number-tbl-td"></td>
                        <td>Description of Involvement</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td class="statement-number-tbl-td"></td>
                        <td colspan="3">
                          <div class="a-textarea-box a-field-length-validation form-inlines">
                            <ap-field [title]="''" [fieldId]="'identifyAllInvolvedInTrDescriptionOfInvolvement'" [hideTitleOnInput]="true">
                    <textarea appkit-field maxlength="100" [(ngModel)]="tab.identifyAllInvolvedInTrDescriptionOfInvolvement" aria-label="Identify all involved in tr description of involvement"></textarea>
                              <ap-field-counter [max]="100" [value]="tab.identifyAllInvolvedInTrDescriptionOfInvolvement"></ap-field-counter>
                            </ap-field>
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <ap-button class="ap-mr-spacing-3" [btnType]="'secondary'"
                    [compact]="true" (onClick)="clearEntity('partSeven', index)">
                    <span class="Appkit4-icon a-btn-icon icon-refresh-fill"></span>Clear this Entry
                  </ap-button>

                </div>

              </mat-tab>
            }
          </mat-tab-group>

        </div>

      </div>

    </div>
  </div>
